// extracted by mini-css-extract-plugin
module.exports = {"right-arrow-decal":"RightArrowDecal_right-arrow-decal__4DSB4"};